export default  ps => new Promise((resolve, reject) => {
    let cnt = 0;
    ps.map(p => p.then(resolve).catch((err) => ++cnt === ps.length && reject(err)))
})
